import React, { Fragment, useMemo, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Grid, Typography } from "@mui/material";
import BackgroundPattern1 from "components/common/card/BackgroundPattern1";
import CarouselComponent from "components/carousel/Carousel.component";
// import AuthGrayCard from "assets/images/auth/auth-grey-card.png";
// import AuthPurpleCard from "assets/images/auth/auth-gold-card.png";
import Smartcity from "assets/images/smartcity.png";
import LocalizationSection from "layout/MainLayout/Header/LocalizationSection";
import { useTranslation } from "react-i18next";
import MobileSection from "layout/MainLayout/Header/MobileSection";
import { DateTime } from "luxon";

// styles
const Cards = styled("span")({
  "&:after": {
    content: '""',
    position: "absolute",
    top: "20%",
    left: "20%",
    width: 400,
    backgroundSize: 400,
    height: 300,
    backgroundImage: `url(${Smartcity})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    animation: "15s wings ease-in-out infinite",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    top: "23%",
    left: "37%",
    width: 243,
    height: 210,
    backgroundSize: 380,
    //backgroundImage: `url(${AuthGrayCard})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    animation: "15s wings ease-in-out infinite",
    animationDelay: "1s",
  },
});



const WrapperSliderCard = ({ children }) => {
  const { t, i18n } = useTranslation()
  const [nowDate, setNowDate] = useState(`${DateTime.now().toLocaleString(
    { day: 'numeric', month: "long", year: "numeric", }, {
    locale: i18n?.language ? i18n.language : "it",
  })},
  ${DateTime.now().toLocaleString(
    { hour: '2-digit', minute: '2-digit', }, {
    locale: i18n?.language ? i18n.language : "it",
  })} `)

  // carousel items
  const items = useMemo(() => (
    [
      {
        title: "Smart City Xplore",
        description: t('Management of environmental monitoring network and anthropic load'),
      },
    ]
  ), [t])

  // eslint-disable-next-line
  const timeDateInterval = setInterval(() => {

    setNowDate(`${DateTime.now().toLocaleString(
      { day: 'numeric', month: "long", year: "numeric", }, {
      locale: i18n?.language ? i18n.language : "it",
    })},
    ${DateTime.now().toLocaleString(
      { hour: '2-digit', minute: '2-digit', }, {
      locale: i18n?.language ? i18n.language : "it",
    })} `)
  }, 1000);

  return (
    <Fragment>
      <Box m={1} sx={{
        display: { xs: 'block', sm: 'none' },

      }}>
        <MobileSection />
      </Box>
      <Grid container justifyContent="space-between" alignItems="center">

        <Grid item container justifyContent="center" md={6} lg={7}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
              {children}
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          md={6}
          lg={5}
          sx={{
            position: "relative",
            alignSelf: "stretch",
            display: { xs: "none", md: "block" },
          }}
        >


          <BackgroundPattern1>

            <Grid
              item
              container
              //alignItems="flex-end"
              justifyContent="center"
              spacing={3}
            >

              <Grid item container xs={12} alignItems='flex-start' display='flex' justifyContent='end' m={2} sx={{ zIndex: 999 }}>
                <Grid item alignItems='center' display='flex'>
                  <Typography textTransform='capitalize' variant='caption' ml={2}>
                    {nowDate}
                  </Typography>

                  <LocalizationSection />

                </Grid>

              </Grid>
              <Grid item xs={12}>
                <span />
                <Cards />
              </Grid>
              <Grid item xs={12} display='flex' alignItems="flex-end">
                <Grid item container justifyContent="center" sx={{ pb: 2 }}>
                  <Grid
                    item
                    xs={10}
                    lg={8}
                    sx={{ height: "100%", width: "100%" }}
                  // sx={{ '& .slick-list': { pb: 2 } }}
                  >
                    <CarouselComponent items={items} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </BackgroundPattern1>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default WrapperSliderCard;
